export const USERS_LOADING  = "USERS_LOADING";
export const USERS_SET_DATA  = "USERS_SET_DATA";
export const USERS_ERROR    = "USERS_ERROR";
export const USERS_REMOVE_DATA    = "USERS_REMOVE_DATA";

export const ADD_CHATED_USER_START = "ADD_CHATED_USER_START";
export const ADD_CHATED_USER_SUCCESS = "ADD_CHATED_USER_SUCCESS";
export const ADD_CHATED_USER_ERROR = "ADD_CHATED_USER_ERROR";

export const LIST_CHATED_USER_START = "LIST_CHATED_USER_START";
export const LIST_CHATED_USER_SUCCESS = "LIST_CHATED_USER_SUCCESS";
export const LIST_CHATED_USER_ERROR = "LIST_CHATED_USER_ERROR";

export const CHAT_FETCH_START = "CHAT_FETCH_START";
export const CHAT_FETCH_SUCCESS = "CHAT_FETCH_SUCCESS";
export const CHAT_FETCH_ERROR = "CHAT_FETCH_ERROR";

export const REAL_TIME_CHAT = "REAL_TIME_CHAT";